<template>
  <div>
    <div id="Waves">
      <!-- Header -->
      <div class="header py-7 py-lg-8 pt-lg-9">
        <b-container>
          <div class="header-body text-center mb-7">
            <b-row class="justify-content-center">
              <b-col xl="5" lg="6" md="8" class="px-5">
                <h1 class="text-lead text-white">An unexpected error occurred.</h1>
                <router-link to="/home" class="font-weight-bold text-white mt-5" custom v-slot="{ navigate}">Back to
                  <a  @click="navigate" @keypress.enter="navigate" role="link"><u><span class="text-info" >Home</span></u></a>
                </router-link>
              </b-col>
            </b-row>
          </div>
        </b-container>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ErrorPage',
  mounted() {
    document.title = 'Error'
  }
};
</script>
